import React from 'react';
import TranslationContainer from '../../translation/translation_container';
import { PromotionText } from './promotion_text';

function Budget() {
    return (
        <TranslationContainer
            targetProperties={{
                flagText: { translationKey: 'catalog-promotions-promotion-text-flag-text-budget' },
                headline: { translationKey: 'catalog-promotions-promotion-text-headline-budget' },
                content: { translationKey: 'catalog-promotions-promotion-text-content-budget' },
            }}
        >
          <PromotionText
              type="budget"
              flagText="will-be-replaced"
              headline="will-be-replaced"
              content="will-be-replaced"
          />
        </TranslationContainer>
    );
}

export { Budget };